









import { Component, Prop, Vue } from 'vue-property-decorator'
import LoadingCover from '@/components/LoadingCover.vue';

@Component({
  components: {
    LoadingCover,
  },
})
export default class LoadingWithText extends Vue {
  @Prop({ default: 'Loading...' }) loadingText!: string;
  timer: any = null;

  mounted() {
    this.timer = setTimeout(() => {
      this.loadingText = 'Your connection is slow, please wait...';
    }, 30000);
  }

  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
